import { createBrowserRouter, RouterProvider, type RouteObject } from "react-router-dom";
import pageRoutes, { dashboardPath, type IRoute } from "./route";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import type React from "react";
import CustomErrorPage from "@/errors/error";

const getRoutePath = (path: string, idx: number) => {
	if (path.startsWith("/")) {
		return path;
	}

	return dashboardPath + pageRoutes[idx].path + path;
};

const allRoutes = (pageRoutes: IRoute[], idx = 0) =>
	pageRoutes.flatMap((route: IRoute, idxx): RouteObject | undefined => {
		if (route.path) {
			return route.children && route.children.length > 0
				? (allRoutes(route.children, idxx) as RouteObject)
				: ({
					path: route.path !== dashboardPath && route.type !== "index"
						? getRoutePath(route.path, idx)
						: (route.path || ""),
					element: route.type !== "index"
						? (<ProtectedRoute>{route.component || <></>}</ProtectedRoute>)
						: route.component,
					errorElement: <CustomErrorPage />
				} as RouteObject);
		}
	});

const router = createBrowserRouter(allRoutes(pageRoutes) as RouteObject[]);

const AppRouter: React.FC = () => {
	return <RouterProvider router={router} />;
}

export default AppRouter;